export const makeEmail = (login: string) => {
    return login.includes('@') ? login : `${login}@yandex.ru`;
};
